import { useState } from "react";
import type { Story } from "@/mocks/stories";
import { formatCount } from "@/utils/format";
import { catStyles, catNameMap } from "./catStyle";
import { CollectButton, LikeButton } from "./StoryCard";

export default function StoryRow({
  story,
  rank,
}: {
  story: Story;
  rank?: number;
}) {
  const st = catStyles[story.category];
  const [open, setOpen] = useState(false);

  return (
    <article className="group rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-background-100/60 md:p-5">
      <div className="flex items-start gap-4">
        {rank !== undefined && (
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base ${
              rank <= 3 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-500"
            }`}
          >
            {rank}
          </span>
        )}
        <button onClick={() => setOpen((v) => !v)} className="min-w-0 flex-1 text-left">
          <span className="flex flex-wrap items-center gap-2">
            <span
              className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${st.badge}`}
            >
              {catNameMap[story.category]}
            </span>
            <span className="text-xs text-foreground-400">
              <i className="ri-eye-line mr-0.5" />
              {formatCount(story.views)}
            </span>
          </span>
          <h3 className="mt-1.5 font-heading text-base leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
            {story.title}
          </h3>
          <p className={`text-sm leading-relaxed text-foreground-600 ${open ? "" : "line-clamp-2"}`}>
            {open ? story.content.join("") : story.excerpt}
          </p>
          {open && (
            <span className="mt-1 inline-flex items-center gap-1 text-xs font-bold text-primary-600">
              {story.reaction} 太真实了，笑死
            </span>
          )}
        </button>
        <div className="flex shrink-0 flex-col items-end gap-1.5">
          <LikeButton count={story.likes} compact />
          <CollectButton compact />
        </div>
      </div>
    </article>
  );
}